import { EducationalAttainmentValue } from './../../../../common/person/model/person-values';
import { ErpPersonService } from './../../../../common/person/service/erp-person-service';
import { Component, OnInit } from '@angular/core';
import { WithSuggestionsComponent } from './with-suggestions.component';

@Component( {
    selector: 'erp-pbw-hochschul',
    templateUrl: './with-suggestions.component.html'
} )
export class EducationalAttainmentComponent extends WithSuggestionsComponent<EducationalAttainmentValue> implements OnInit {

    constructor( private readonly personService: ErpPersonService ) {
        super( 'rm.erp.jobapplication.JobApplication.educationalAttainment' );
    }

    ngOnInit(): void {
        this.personService.getEducationalAttainmentValues().subscribe( values => {
            this.unfiltered = values.filter( v => v.relevantForJobApplication );
        } );
    }

    set value( t: EducationalAttainmentValue | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.educationalAttainment = t;
        }
    }

    get value(): EducationalAttainmentValue | undefined {
        return this.jobapplication?.educationalAttainment;
    }
}
